import { AppDeleteActionsType } from "../reducers/appDeleteReducer";

export const addAppToDeleteQueue = (appid) => ({
  type: AppDeleteActionsType.ADD_TO_DELETION_QUEUE,
  payload: { appid },
});

export const removeAppFromDeleteQueue = (appid) => ({
  type: AppDeleteActionsType.REMOVE_FROM_DELETION_QUEUE,
  payload: { appid },
});

export const setDeletingApp = (appid) => ({
  type: AppDeleteActionsType.SET_DELETING_APP,
  payload: { appid },
});
